import { LabelColor, SharedOption, UserLabel } from '@app/pcs/models';
import { Color } from 'pcs-component-library';
import * as R from 'ramda';

export const EMPTY_USER_LABEL = {
  label: {
    name: null,
    description: null
  },
  creator: true
} as UserLabel;

const getLabelIcon = R.cond([
  [R.equals(SharedOption.NotApplicable), R.always('reply')],
  [R.equals(SharedOption.Yes), R.always('people')],
  [R.T, R.always('')]
]);
type GetSharedType = (label: UserLabel) => SharedOption;
export const getSharedType: GetSharedType = R.prop('sharedType');

type GetIconForLabel = (userLabel: UserLabel) => string;
export const getIconForLabel = <GetIconForLabel>R.compose(getLabelIcon, getSharedType);

export type GetLabelId = (userLabel: UserLabel) => number;
export const getLabelId: GetLabelId = R.path(['label', 'id']);
export const labelIdEq = R.pathEq(['label', 'id']);
export const isLabelSelected: any = R.pathEq(['selected'], true);

type GetLabelName = (userLabel: UserLabel) => string;
export const getLabelName: GetLabelName = R.path(['label', 'name']);

type GetLabelDescription = (userLabel: UserLabel) => string;
export const getLabelDescription: GetLabelDescription = R.path(['label', 'description']);

type GetUserLabelString = (userLabel: UserLabel) => string;
export const getFirstName: GetUserLabelString = R.path(['creatorUser', 'firstName']);
export const getLastName: GetUserLabelString = R.path(['creatorUser', 'lastName']);
export const getCreatorFullName = (userLabel: UserLabel) => R.join(' ', [getFirstName(userLabel), getLastName(userLabel)]);

export const isLabelSharedWithUser = (userLabel: UserLabel) => userLabel.sharedType === SharedOption.NotApplicable;

type GetLabelColor = (userLabel: UserLabel) => LabelColor;
export const getLabelColor: GetLabelColor = R.path(['color', 'id']);

type GetColorForLabel = (labelColor: LabelColor) => Color;
export const getColorForLabel: GetColorForLabel = R.cond([
  [R.equals(LabelColor.Violet), R.always({id: LabelColor.Violet, value: 'color-2'})],
  [R.equals(LabelColor.Aqua), R.always({id: LabelColor.Aqua, value: 'color-3'})],
  [R.equals(LabelColor.Green), R.always({id: LabelColor.Green, value: 'color-4'})],
  [R.equals(LabelColor.Yellow), R.always({id: LabelColor.Yellow, value: 'color-5'})],
  [R.equals(LabelColor.Orange), R.always({id: LabelColor.Orange, value: 'color-6'})],
  [R.T, R.always({id: LabelColor.Blue, value: 'color-1'})]
]);
